var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showDialog,
          expression: "showDialog",
        },
      ],
      staticClass: "ubi_translate",
    },
    [
      _c("div", { staticClass: "mask" }),
      _vm._v(" "),
      _c("div", { staticClass: "ubi_translate_box" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "info" }, [
            _vm._v(" " + _vm._s(_vm.$t("common.pleaseSelectLanguage")) + " "),
          ]),
          _vm._v(" "),
          _c(
            "i",
            { staticClass: "aui_close2", on: { click: _vm.closeDialog } },
            [_vm._v("×")]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content", staticStyle: { height: "auto" } },
          _vm._l(_vm.lanArray, function (item) {
            return _c(
              "div",
              {
                key: item.key,
                staticClass: "language-detail",
                on: {
                  click: function ($event) {
                    return _vm.changeLanTo(item)
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }